import { T2, P, IconButton, T2Props, Link, LinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';
import confetis from '../../../assets/Confetis-EC.png';

export const StyledBackgroundDiv = styled.div`
    background-image: url(${confetis});
    position: relative;
    background-size: cover;
    padding: 36px 24px;
    margin-bottom: 36px;
    border-radius: 4px;
`;

export const StyledCloseButton = styled(IconButton)`
  color: ${({ theme }) => theme.colors.blue5};
  &:hover {
    color: ${({ theme }) => theme.colors.blue10};
  }
  &:active {
    color: ${({ theme }) => theme.colors.blue3};
  }
  position: absolute;
  right: 0px;
  top: 0;
`;

export const StyledT = styled<FC<T2Props>>(T2)`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 800;
  line-height: 1.17;
  margin-bottom: 16px;
`;

export const StyledP = styled(P)`
  line-height: 1.29;
`;

export const StyledActions = styled(P)`
  margin-top: 16px;
  margin-bottom: 0;
`;

export const StyledLink = styled<FC<LinkProps>>(Link)`
  font-weight: 600;
  margin-right: 24px;

  &:last-child {
    margin-right: 0;
  }
`;
